<template>
    <div class="left-category">
        <el-collapse class="category" v-model="activeNames">
            <el-collapse-item title="文献名称" name="2">
                <div class="items">
                    <div v-for="(item, index) of recordsList" :key="index" class="category-item">
                        <div class="title" @click="goToPage(item)">{{item.title}}</div>
                    </div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import bookApi from '@/api/book'

export default {
    data () {
        return {
            activeNames: ['1', '2'],
            currentBookType: {},
            recordsByYear: [],
            recordsByType: [],
            recordsList: []
        }
    },
    mounted () {},
    methods: {
        getItemList () {
            this.recordsList = [];
            let that = this;

            bookApi.getBook({
               path: 'getBookDataWithPrs',
              pageindex: 1,
             pageSize: 10,
             bookType: 'paper',
              schemaType: 'base'

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    that.total = response.data.count;
                    that.recordsList = response.data.rows;
                }
            })
        },
        changeBookSelect (item) {
            this.currentBookType = item;
            this.getItemList();
            if (item.key === 'base') {
                this.getItemStatisticsByYear();
            }
        },
        goToPage (item) {
        let routeData = this.$router.resolve({
          path: '/bookDetail',
          query: {
            bookId: item.sourceID,
            bookType: 'book',
            schemaType: 'base'
          }
        });

        // 必要操作，否则不会打开新页面
        window.open(routeData.href, '_blank');
    }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.left-category {
    width: 280 * @uw;
    height: auto;
    // margin-top: 60px;
    // box-shadow: 0px 0px 10px 5px #e0e0e0;
    // padding-left: 10 * @uw;
    // padding-right: 10 * @uw;
    // height: 50 *@uw;
    // background: bisque;

    .category {
        box-shadow: 0px 0px 10px 5px #e0e0e0;
        padding-left: 10 * @uw;
        padding-right: 10 * @uw;
        margin-bottom: 20 * @uh;
        border-radius: 5 * @uw;

        .items {
            max-height: 1000 * @uh;
            overflow-y: auto;
        }

        .category-item {
            margin: 0px 8 * @uw 5 * @uh 8 * @uw;
            font-size: 14 * @uw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 20 * @uw;
        }

        .title{
            cursor: pointer;
        }
    }
}

:deep(.el-collapse-item__header.is-active) {
    font-size: 16 * @uw;
    color: #8d5e1a;
}
</style>
